import { TextTooltip } from "@/components/ui/text-tooltip"
import React from "react"

interface ITooltip {
  title: string | React.ReactNode
  children: React.ReactNode
  tooltipEnabled?: boolean
}

function Tooltip({ title, children, tooltipEnabled = true }: ITooltip) {
  if (!children) {
    return <></>
  }

  if (tooltipEnabled) {
    return <TextTooltip title={title}>{children}</TextTooltip>
  }

  return <>{children}</>
}

export default Tooltip
